module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('nav', {
    staticClass: "navbar navbar-toggleable-md navbar-light bg-faded"
  }, [_c('a', {
    staticClass: "navbar-brand",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("CSV 2 Email")]), _vm._v(" "), _c('div', {
    staticClass: "pull-right"
  }, [_vm._v("Easily send hundreds of mails via CSV")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-5b8d18b0!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/SiteHeader.vue
// module id = 84
// module chunks = 2